<template>
  <div class="home">
    <div class="home-page-message-top">
      <div class="wei_mian_top">
        <div class="wei_mian_top_left">
          <h3 class="wei_info_top">
            <div class="wei_info_all">
              <span></span>
              <span>消息中心</span>
            </div>
            <!-- <div class="wei_notice">
						  <span>
							待办通知
							<i>15</i>
						  </span>
						  <span>
							系统通知
							<i></i>
						  </span>
						</div> -->
          </h3>
          <a-list
            size="small"
            class="hospital-list"
            bordered
            :dataSource="noteData"
            :locale="{ emptyText: '暂无数据' }"
          >
            <a-list-item
              :class="(item.messageTitleType == 22 || item.messageTitleType == 23)?'note-title-a':'note-title-a note-title-adline'"
              slot="renderItem"
              slot-scope="item"
              @click="message(item)"
            >
              <span
                class="wei_main_left_a"
                v-if="
                  item.messageTitleType == 22 || item.messageTitleType == 23
                "
                ><span></span>{{ mdMessageContentHtml(item) }}</span
              >
              <span class="wei_main_left_a" v-else
                ><span></span>{{ item.messageContent }}</span
              >
              <span class="wei_main_left_span">{{ item.createTime }}</span>
            </a-list-item>
            <!-- <div slot="header">Header</div> -->
            <div slot="footer">
              <router-link
                v-if="noteData.length > 0"
                class="wei_see_all"
                to="/note"
                >查看全部</router-link
              >
            </div>
          </a-list>
        </div>
        <div class="wei_main_top_right">
          <div :style="{ width: '372px', height: '336px', border: 'none' }">
            <a-calendar
              :fullscreen="false"
              @panelChange="onPanelChange"
              v-if="menus.length !== 1"
            />
            <div class="wei_menu_one" v-if="menus.length == 1">
              <div class="home-page-link-module">
                <div class="link-module-icon-div">
                  <img :src="menus[0].icon" alt />
                </div>
                <div class="link-module-content">
                  <div class="link-module-title">{{ menus[0].name }}</div>
                  <div class="link-module-desc">{{ menus[0].desc }}</div>
                  <router-link :to="menus[0].path" class="wei_link_a"
                    >点击进入 >></router-link
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="home-page-work-center">
      <group-content
        icon="/icon/Workbench.png"
        title="工作中心"
        v-if="menus.length > 1"
      >
        <link-module
          v-for="item in menus"
          :key="item.name"
          :icon="item.icon"
          :title="item.name"
          desc
          @link="goToLink(item)"
        ></link-module>
      </group-content>
      <group-content icon="/icon/yiyuan.png" title="医院样本量">
        <!-- <distribute-echart :params="mapParams"></distribute-echart> -->
        <geo-map :params="mapParams" showTitle="false"></geo-map>
      </group-content>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
const data = [
  "Racing car sprays burning fuel into crowd.",
  "Japanese princess to wed commoner.",
  "Australian walks 100km after outback crash.",
  "Man charged over missing wedding girl.",
  "Los Angeles battles huge wildfires.",
  "Man charged over missing wedding girl.",
  "Los Angeles battles huge wildfires.",
];
import { mapState } from "vuex";
import GroupContent from "@/components/homepage/groupContent";
import LinkModule from "@/components/homepage/linkModule";
import DistributeEchart from "@/components/homepage/distributeEchart";
import GeoMap from "@/components/echarts/map";

export default {
  name: "home",
  components: { GroupContent, LinkModule, DistributeEchart, GeoMap },
  computed: {
    ...mapState({
      multipage: (state) => state.setting.multipage,
      user: (state) => state.account.user,
    }),
    avatar() {
      return `static/avatar/${this.user.avatar}`;
    },
  },
  data() {
    return {
      data,
      noteData: [],
      menus: [],
      allMenus: [
        {
          path: "/statistics",
          name: "统计分析",
          icon: "/icon/tongjifenxi.png",
          desc: "患者记录（ 20 ）",
        },
        {
          path: "/diagnosis",
          name: "就诊流程",
          icon: "/icon/liucheng-3.png",
        },
        {
          path: "/job",
          name: "作业管理",
          icon: "/icon/zuoye.png",
        },
        {
          path: "/report",
          name: "报告管理",
          icon: "/icon/xingzhuang.png",
        },
        {
          path: "/sufferer",
          name: "患者管理",
          icon: "/icon/huanzhe2.png",
        },
        {
          path: "/sample",
          name: "样本管理",
          icon: "/icon/yangbenguanli.png",
        },
        {
          path: "/turn/user",
          name: "总控设置",
          icon: "/icon/shezhi-4.png",
        },
      ],
      mapParams: {
        timeType: 0, //全部
        startTime: "",
        endTime: "",
        mapDisplay: 1,
      },
    };
  },
  methods: {
    onPanelChange(value, mode) {},
    setRead(ids) {
      if (ids) {
        this.$put("/message", {
          ids: ids,
        }).then((res) => {
          console.log("消息通知已读成功");
        });
      }
    },
    message(item) {
      if (item) {
        if (item.messageTitleType) {
          if (item.messageTitleType) {
            this.setRead(item.id);
            if (item.messageTitleType == 13) {
              this.$router.push({
                path: "/sufferer",
              });
            } else if (
              item.messageTitleType == 2 ||
              item.messageTitleType == 4 ||
              item.messageTitleType == 5 ||
              item.messageTitleType == 17 ||
              item.messageTitleType == 19 ||
              item.messageTitleType == 20
            ) {
              this.$router.push({
                path: "/diagnosis/details",
                query: {
                  id: item.bid,
                },
              });
            } else if (item.messageTitleType == 6) {
              this.$router.push({
                path: "/sample",
              });
            } else if (
              item.messageTitleType == 7 ||
              item.messageTitleType == 8 ||
              item.messageTitleType == 15 ||
              item.messageTitleType == 21
            ) {
              this.$router.push({
                path: "/job/details",
                query: {
                  id: item.bid,
                },
              });
            } else if (
              item.messageTitleType == 9 ||
              item.messageTitleType == 10 ||
              item.messageTitleType == 11 ||
              item.messageTitleType == 12 ||
              item.messageTitleType == 16
            ) {
              this.$router.push({
                path: "/report/details",
                query: {
                  id: item.bid,
                },
              });
            } else if (item.messageTitleType == 3) {
              this.$router.push({
                path: "/sufferer/detail",
                query: {
                  id: item.bid,
                },
              });
            }
          }
        }
      }
    },
    mdMessageContentHtml(item) {
      let splitContent = item.messageContent
        ? item.messageContent.split("#$%")
        : [];
      let resultStr = "";
      if (item.messageTitleType == 22) {
        resultStr =
          "MD审核了协助组条码为" +
          splitContent[0] +
          "的样本：" +
          splitContent[1];
      } else {
        resultStr =
          splitContent[0] +
          "回了你MD审核：" +
          splitContent[1] +
          ";“" +
          splitContent[2] +
          "“";
      }
      return resultStr;
    },
    initMenus() {
      const userMenus = this.$db.get("userMenusAllMenus");
      if (userMenus.length) {
        this.allMenus.forEach((item) => {
          let isHave = userMenus.find((d) => d.name == item.name);
          if (isHave) {
            if (item.name == "总控设置") {
              item.path =
                isHave.children.length > 0 ? isHave.children[0].path : "/404";
            }
            this.menus.push(item);
          }
        });
      }
    },
    goToLink(item) {
      this.$router.push(item.path);
    },
    getNoteData() {
      let userid = this.$db.get("userInfo").userId;
      this.$get("/message/page", {
        pageSize: 6,
        pageNum: 1,
        userId: userid,
        optTimeRange: 0,
        messageStatus: 0,
      }).then((res) => {
        this.noteData = res.data.data.rows;
      });
    },
  },
  created() {
    this.$store.state.account.isActive = false;
  },
  mounted() {
    this.initMenus();
    this.getNoteData();
  },
};
</script>

<style lang="scss" scoped>
.home {
  .hospital-list {
    position: relative;
    /deep/ .ant-list-footer {
      position: absolute;
      bottom: -48px;
      z-index: 9;
      right: 0;
    }
  }
  .home-page-message-top {
    width: 100%;
    background: #e6e8eb;
    padding: 30px 0;
    .wei_mian_top {
      width: 1200px;
      margin: 0 auto;
      /deep/ .ant-list-footer {
        text-align: right;
      }
    }
  }
}

/deep/ .wei_mian_top {
  width: 100%;
  height: 336px;
  background: #f0f2f5;
  .wei_mian_top_left {
    border: 1px solid #f0f2f5;
    width: 792px;
    height: 100%;
    background: #fff;
    float: left;
    .wei_info_top {
      overflow: hidden;
      border-bottom: 1px solid #e5ecfd;
      margin-bottom: 0;
      padding: 15px 35px 7px 30px;

      .wei_info_all {
        float: left;
        span:first-child {
          display: block;
          float: left;
          width: 24px;
          height: 26px;
          margin-right: 5px;
          margin-top: -2px;
          background: url("../assets/image/imgHome/bell_3.png") left center
            no-repeat;
        }
      }

      .wei_notice {
        float: right;
        span:first-child {
          margin-right: 67px;
          position: relative;
          i {
            position: absolute;
            right: -18px;
            top: -10px;
            width: 19px;
            height: 19px;
            color: #fff;
            background: #ea3622;
            font-size: 12px;
            line-height: 19px;
            text-align: center;
            border-radius: 50%;
            font-style: normal;
          }
        }
        span:last-child {
          position: relative;
          i {
            position: absolute;
            right: -9px;
            top: -5px;
            width: 7px;
            height: 7px;
            background: #ea3622;
            border-radius: 50%;
          }
        }
      }
    }
    .ant-list-footer {
      text-align: right;
      height: 40px;
      .wei_see_all {
        margin-right: 19px;
        color: #428ef7;
      }
    }
    .wei_main_left_span {
      position: absolute;
      right: 35px;
      color: #a4a4a4;
    }
	.note-title-a{
		cursor: pointer;
		&.note-title-adline{
			text-decoration-line: underline;
		}
	}
    .wei_main_left_a {
      display: block;
      max-width: 530px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: #162232;
      span {
        width: 11px;
        display: block;
        height: 11px;
        float: left;
        /*margin-right: 10px;*/
        /*margin-left: 10px;*/
        margin-top: 6px;
        /*background: url("../assets/image/imgHome/red.png") left center no-repeat;*/
      }
    }
    .ant-list-bordered {
      // border:1px solid #f0f2f5;
      border: none;
      .ant-list-item {
        border-bottom: 1px solid #e5ecfd;
        padding-left: 30px;
        height: 40px;
      }
      .ant-list-item:hover {
        background-color: #558cf0;
        a,
        span {
          color: #fff;
        }
      }
    }
  }
  .wei_main_top_right {
    float: right;
    background-color: #fff;
    .ant-fullcalendar {
      border-top-color: #e5ecfd;
    }
    .ant-fullcalendar-value:active {
      background-color: #558cf0;
      border-radius: 50%;
    }
    .ant-fullcalendar-value:hover {
      border-radius: 50%;
      background-color: #558cf0;
    }
    .ant-fullcalendar-selected-day .ant-fullcalendar-value,
    .ant-fullcalendar-month-panel-selected-cell .ant-fullcalendar-value {
      background-color: #558cf0;
      border-radius: 50%;
    }
    .ant-fullcalendar-month-panel-cell .ant-fullcalendar-value {
      width: 48px;
      height: 48px;
      line-height: 48px;
      border-radius: 50%;
    }
  }
}

.home-page-work-center {
  width: 1200px;
  margin: 0 auto;
  padding: 30px 0;
}

.wei_menu_one {
  background-color: #558cf0;
  width: 100%;
  height: 100%;
  border-top: 1px solid #558cf0;
  .home-page-link-module {
    margin-top: 92px;
    cursor: pointer;
  }
  .link-module-icon-div {
    width: 110px;
    height: 110px;
    margin: 36px auto 22px;
    border-radius: 110px;
    background: #e5ecfd;
    text-align: center;
    line-height: 110px;
    overflow: hidden;
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }

  .link-module-content {
    text-align: center;
    .link-module-title {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: bold;
      color: rgba(22, 34, 50, 1);
      color: #fff;
    }
    .link-module-desc {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: bold;
      color: rgba(164, 164, 164, 1);
      line-height: 36px;
      color: #fff;
    }
    .wei_link_a {
      display: block;
      margin-top: 28px;
      color: #fff;
    }
  }
}
</style>